import { InputProps } from '..';

export function List(props: InputProps) {
  return <div {...props}>List</div>;
}

export default List;
